import * as React from "react";
import { motion } from "framer-motion";
const HamburgerSvg = ({ menuClicked, color, opacity }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 90.2 110.7",
    }}
    viewBox="0 0 90.2 110.7"
  >
    <motion.path
      animate={menuClicked && { opacity: 1 }}
      initial={{ opacity: 0 }}
      d="M48.5 43c-9.3 4.8-18.6 9.7-27.9 14.5-1.8-.8-2.7-1.2-4.4-2.1 7.5-3.9 11.3-5.9 18.8-9.8-8.2 3.6-12.4 5.4-20.6 9-1.3-.6-1.9-.9-3.2-1.5l16.5-10.5c-7.4 3.8-11 5.8-18.4 9.6-1.8-.8-2.7-1.2-4.4-2.1 9.3-4.8 18.6-9.7 27.9-14.5 2.6 1.2 4 1.8 6.6 3.1-1.5 1-3.3 2.1-5.3 3.4-2.5 1.6-3.8 2.4-6.4 4 5.7-2.5 8.5-3.7 14.2-6.2 2.6 1.3 3.9 1.9 6.6 3.1zM50.5 44l8.5 4c-2.2 1.2-3.3 1.7-5.6 2.9-1.4-.6-2-.9-3.4-1.6-2.1 1.1-3.2 1.7-5.3 2.8 1.3.6 1.9.9 3.2 1.5-2.1 1.1-3.2 1.7-5.3 2.8-1.3-.6-1.9-.9-3.2-1.5-2.5 1.3-3.7 1.9-6.1 3.2 1.5.7 2.2 1 3.7 1.7-2.2 1.2-3.3 1.7-5.6 2.9-3.5-1.6-5.3-2.5-8.8-4.1C32 53.7 41.2 48.8 50.5 44zM72.2 54.1c-9.3 4.8-18.6 9.7-27.9 14.5-1.8-.8-2.7-1.2-4.5-2.1 4-3.1 6-4.7 10-7.8-5.1 2.6-7.6 4-12.7 6.6-1.7-.8-2.6-1.2-4.3-2 9.3-4.8 18.6-9.7 27.9-14.5 1.7.8 2.6 1.2 4.3 2-3.9 3.1-5.8 4.7-9.7 7.9l12.5-6.5c1.8.7 2.7 1.1 4.4 1.9zM85.8 60.4c-7.4 3.9-11.2 5.8-18.6 9.7-2.1 1.1-3.6 1.9-4.6 2.3-.9.4-2.1.7-3.5 1-1.4.2-2.7.3-3.9.2-1.2-.1-2.4-.4-3.4-.9-1.2-.5-1.9-1.2-2.3-1.9-.3-.7-.3-1.4.1-2.1.4-.7 1.1-1.3 2-1.8.9-.5 2.9-1.6 6.1-3.3 6.6-3.4 9.9-5.2 16.5-8.6 2 .9 3.1 1.4 5.1 2.4-8.4 4.4-12.5 6.5-20.9 10.9-1.2.6-1.9 1.1-2.2 1.3-.2.2-.2.4.1.5.3.2.7.1 1.2 0 .5-.2 1.4-.6 2.8-1.3 8.2-4.3 12.3-6.4 20.5-10.7 1.9.9 3 1.4 5 2.3z"
      // id="backline"
      // d="m31.1 34 59.1 27.9-31.1 14.7L0 48.7z"
      style={{
        opacity: opacity,
        // fill: color,
        enableBackground: "new",
      }}
    />

    <motion.g
      id="up-arrow"
      initial={{ y: 0 }}
      animate={
        menuClicked
          ? { y: 43, transition: { duration: 0.3 } }
          : {
              y: [0, 10, 0],
              transition: {
                times: [0, 1],
                duration: 5,
                repeat: Infinity,
                tupe: "keyframes",
                ease: "easeInOut",
              },
            }
      }
    >
      <path d="M85.4 17.7 48.7.7C47.6.3 46.4 0 45.2 0c-1.1 0-2.3.2-3.4.7L0 19.4v29.4l45.1-21.4 45.1 21.4V25.3c0-3.3-1.9-6.2-4.8-7.6zm2.1 26.7L46.3 24.9c-.4-.2-.8-.3-1.2-.3s-.8.1-1.2.3L2.7 44.4V21.1L42.9 3.2c.7-.3 1.5-.5 2.3-.5s1.6.2 2.3.5l36.7 17c2 .9 3.2 2.9 3.2 5.1v19.1h.1z" />
      <path
        d="M87.5 25.3v19.1L46.3 24.9c-.4-.2-.8-.3-1.2-.3s-.8.1-1.2.3L2.7 44.4V21.1L42.9 3.2c.7-.3 1.5-.5 2.3-.5s1.6.2 2.3.5l36.7 17c2 .9 3.3 2.9 3.3 5.1z"
        className="st1"
      />
    </motion.g>

    <motion.g
      id="down-arrow"
      initial={{ y: 0 }}
      animate={
        menuClicked
          ? { y: -43, transition: { duration: 0.3 } }
          : {
              y: [0, -10, 0],
              transition: {
                times: [0, 1],
                duration: 5,
                repeat: Infinity,
                tupe: "keyframes",
                ease: "easeInOut",
              },
            }
      }
    >
      <path d="M45.1 83.3 0 61.9v23.4c0 3.2 1.9 6.2 4.8 7.5l36.7 17c1.1.5 2.3.8 3.5.8s2.3-.2 3.4-.7l41.8-18.6V61.9L45.1 83.3zm42.4 6.2-40.2 17.9c-.7.3-1.5.5-2.3.5s-1.6-.2-2.3-.5L6 90.5c-2-.9-3.2-2.9-3.2-5.1V66.2L44 85.8c.4.2.8.3 1.2.3s.8-.1 1.2-.3l41.2-19.6v23.3h-.1z" />
      <path
        d="M87.5 66.2v23.3l-40.2 17.9c-.7.3-1.5.5-2.3.5s-1.6-.2-2.3-.5L6 90.5c-2-.9-3.2-2.9-3.2-5.1V66.2L44 85.8c.4.2.8.3 1.2.3s.8-.1 1.2-.3l41.1-19.6z"
        className="st1"
      />
    </motion.g>
  </svg>
);
export default HamburgerSvg;
